import { useContext } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import MyContext from "../../context/Context";

const OrderDetails = () => {
    const context = useContext(MyContext);
    const { getAllOrder, orderDelete } = context;

    // ✅ Function to handle order approval
    const handleApproveOrder = async (orderId) => {
        try {
            const orderRef = doc(fireDB, "order", orderId);

            // ✅ Update Firestore order collection
            await updateDoc(orderRef, {
                cancel: "cancelled",
            });

            console.log("Order cancelled successfully!");

            // ✅ Update state immediately
            context.getAllOrder = getAllOrder.map((order) =>
                order.id === orderId ? { ...order, cancel: "cancelled" } : order
            );
        } catch (error) {
            console.error("Error approving order:", error);
        }
    };

    // ✅ Function to handle status change to "deliver"
    const handleDeliverOrder = async (orderId) => {
        try {
            const orderRef = doc(fireDB, "order", orderId);

            // ✅ Update Firestore document status
            await updateDoc(orderRef, {
                status: "delivered",

            });

            console.log("Order status updated to 'deliver'!");

            // ✅ Update state immediately
            context.getAllOrder = getAllOrder.map((order) =>
                order.id === orderId ? { ...order, status: "deliver" } : order
            );
        } catch (error) {
            console.error("Error updating status to 'deliver':", error);
        }
    };

    return (
        <div>
            <div>
                {/* ✅ Page Title */}
                <div className="py-5">
                    <h1 className="text-xl text-pink-300 font-bold">All Orders</h1>
                </div>

                {/* ✅ Orders Table */}
                <div className="w-full overflow-x-auto hide-scroll-bar">
                    <table className="w-full text-left border-collapse border-pink-100 text-pink-400">
                        <tbody>
                            {/* ✅ Table Headers */}
                            <tr>
                                <th className="h-12 px-6 border border-pink-100 bg-slate-100 text-slate-700 font-bold">S.No.</th>
                                <th className="h-12 px-6 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Order Id</th>
                                <th className="h-12 px-6 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Payment Id</th>
                                <th className="h-12 px-16 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Image</th>
                                <th className="h-12 px-16 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Title</th>
                                <th className="h-12 px-10 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Category</th>
                                <th className="h-12 px-10 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Price</th>
                                <th className="h-12 px-6 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Quantity</th>
                                <th className="h-12 px-6 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Product size</th>
                                <th className="h-12 px-6 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Color</th>
                                <th className="h-12 px-6 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Total Price</th>
                                <th className="h-12 px-6 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Status</th>
                                <th className="h-12 px-6 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Cancel</th>
                                <th className="h-12 px-20 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Name</th>
                                <th className="h-12 px-6 border border-pink-100 bg-slate-100 text-slate-700 font-bold">City</th>

                                <th className="h-12 px-24 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Address</th>
                                <th className="h-12 px-6 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Pincode</th>
                                <th className="h-12 px-6 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Phone Number</th>
                                <th className="h-12 px-12 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Email</th>
                                <th className="h-12 px-14 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Date And Time</th>
                                <th className="h-12 px-6 border border-pink-100 bg-slate-100 text-slate-700 font-bold">Action</th>
                            </tr>

                            {/* ✅ Map Through Orders */}
                            {getAllOrder.map((order, orderIndex) =>
                                order.cartItems.map((item, index) => {
                                    const { id, productImageUrl, title, category, price, quantity,sizeCode,selectedColor } = item;
                                    const totalPrice = price * quantity;
                                    const warrantyAmount = order.warrantyAmount || 0;

                                    return (
                                        <tr key={index} className="text-pink-300">
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{orderIndex + 1}</td>
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{id}</td>
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{order.paymentId}</td>
                                            <td className="h-48  px-2 border border-pink-100 text-slate-500">
                                                <img src={productImageUrl || "/default-image.png"} alt="Product" className=" h-44 object-cover " />
                                            </td>
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{title}</td>
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{category}</td>

                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">₹{price}</td>
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{quantity}</td>
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{sizeCode}</td>
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{selectedColor}</td>
                                            {/* <td className="h-24 px-6 border border-pink-100 text-slate-500">{order.productSize}</td> */}

                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">₹{totalPrice + warrantyAmount}</td>

                                            {/* ✅ Status + Deliver Button */}
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">
                                                {order.status === "confirmed" ? (
                                                    <button
                                                        onClick={() => handleDeliverOrder(order.id)}
                                                        className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                                                    >
                                                        Deliver
                                                    </button>
                                                ) : (
                                                    <span className="text-green-500 font-medium">{order.status}</span>
                                                )}
                                            </td>

                                            {/* ✅ Cancel Status */}
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">
                                                {order.cancel === "requested" ? (
                                                    <button
                                                        onClick={() => handleApproveOrder(order.id)}
                                                        className="bg-green-500 text-white px-3 py-1 rounded"
                                                    >
                                                        Approve
                                                    </button>
                                                ) : order.cancel === "cancelled" ? (
                                                    <span className="text-red-500 font-medium">{order.cancel}</span>
                                                ) : (
                                                    "NA"
                                                )}
                                            </td>
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{order.addressInfo.name}</td>
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{order.addressInfo.city}</td>
                                         

                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{order.addressInfo.address}</td>
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{order.addressInfo.pincode}</td>
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{order.addressInfo.mobileNumber}</td>
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">{order.email}</td>
                                            <td className="h-24 px-6 border border-pink-100 text-slate-500">
                                                {order.time ? order.time.toDate().toLocaleString('en-IN', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    second: '2-digit',
                                                    hour12: true,
                                                    timeZone: 'Asia/Kolkata'
                                                }) : 'N/A'}
                                            </td>

                                            <td onClick={() => orderDelete(order.id)} className="font-semibold h-12 px-6 text-red-600 cursor-pointer">
                                                Delete
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <style dangerouslySetInnerHTML={{ __html: "\n.hide-scroll-bar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.hide-scroll-bar::-webkit-scrollbar {\n  display: none;\n}\n" }} />
        </div>
    );
};

export default OrderDetails;
